import React from "react";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/layout/HeaderOne";
import HeaderHome from "../../components/layout/HeaderHome";
import Breadcrumb from "../../components/Breadcrumb";
import Product from "../../components/product/Product";
import FooterOne from "../../components/layout/FooterOne";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import BottomFooter from "../../components/layout/BottomFooter";
import ProductStore from "../../components/product/ProductStore";

const ProductPage = () => {

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      {/* <HeaderOne /> */}
      <HeaderHome />

      {/* Breadcrumb */}
      <Breadcrumb title={"Products"} />

      {/* Product */}
      {/* <Product /> */}
      <ProductStore />

      {/* ShippingTwo */}
      {/* <ShippingTwo /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />

    </>
  );
};

export default ProductPage;
